const EVENTS = {
  JOIN_EVENT_FAILURE: 'joinEventError',
  USER_STATE_CHANGED: 'userStateChanged',
  STATE_CHANGE: 'eventStateChange',
  LIKE_USER: 'match',
  ERROR: 'appError',
  JOIN_ROOM: 'joinRoom',
  FEATURES_UPDATE: 'featuresUpdate',
  PROFILE_UPDATE: 'profileUpdate',
  DATE_REQUEST: 'dateRequest',
  ACCEPT_DATE_REQUEST: 'acceptDateRequest',
  META_TOUCH: 'metaTouch',
}

export { EVENTS }
